

import { ComponentStyleConfig } from '@chakra-ui/theme';

const tabs: ComponentStyleConfig = {
  baseStyle: {
    root: {
      
    },
    tablist: {
      
    },
    tab: {
      
    },
    tabpanel: {
      p: 0,
      border: 'none'
    }
  },
  variants: {
    line: {
      tablist: {
        border: 'none',
        mt: 'auto',
        bottom: '1px',
        left: '50%',
        transform: 'translateX(-50%)',
        pos: 'absolute'
      },
      tab: {
        color: '#0A0D14',
        fontWeight: 500,
        _selected: {
          borderBottomWidth: '3px',
          color: '#61A318'
        },
        _active: {
          bg: 'none'
        }
      }
    },
    view: {
      tablist: {
        border: 'none',
        borderRadius: '10px',
        bg: 'rgba(226, 228, 233, 0.50)',
        padding: '4px'
      },
      tab: {
        m: 0,
        fontSize: '14px',
        height: '30px',
        padding: '5px 20px',
        lineHeight: '20px',
        color: '#868C98',
        fontWeight: 'medium',
        borderBottomWidth: 0,
        whiteSpace: 'nowrap',
        _selected: {
          color: 'black',
          bgColor: 'white',
          borderRadius: '6px',
          boxShadow: '0px 6px 10px 0px rgba(27, 28, 29, 0.06), 0px 2px 4px 0px rgba(27, 28, 29, 0.02)'
        },
        _active: {
          bg: 'none'
        }
      }
    }
  },
  sizes: {
    md: {
      tab: {
        pb: '18px',
        px: 0,
        ml: 8
      }
    }
  }
};

export default tabs;
